import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import HamburgerMenu from './buttons/HamburgerMenu';
import Logo from './Logo';

function Nav() {
	const location = useLocation();

	return (
		<nav className='navbar sticky top-0 z-50 flex h-24 justify-between gap-5 bg-primary text-base-100'>
			<NavLink to='/' className='flex'>
				<div className='pl-5 pr-3'>
					<Logo height={'h-12'} />
				</div>
				<span className='font-heading text-xs md:text-lg lg:text-2xl'>
					Marshall Academy of the Arts Vocal Music
				</span>
			</NavLink>
			<div className='hidden gap-5 px-10 font-bold md:flex'>
				<NavLink
					to='/'
					className={
						location.pathname === '/' &&
						'text-accent underline underline-offset-4'
					}
				>
					Home
				</NavLink>
				<NavLink
					to='/about'
					className={
						location.pathname === '/about' &&
						'text-accent underline underline-offset-4'
					}
				>
					About
				</NavLink>
				<NavLink
					to='/calendar'
					className={
						location.pathname === '/calendar' &&
						'text-accent underline underline-offset-4'
					}
				>
					Calendar
				</NavLink>
				<NavLink
					to='/families'
					className={
						location.pathname === '/families' &&
						'text-accent underline underline-offset-4'
					}
				>
					Families
				</NavLink>
				<NavLink
					to='/gallery'
					className={
						location.pathname === '/gallery' &&
						'text-accent underline underline-offset-4'
					}
				>
					Gallery
				</NavLink>
			</div>
			<div className='md:hidden'>
				<HamburgerMenu />
			</div>
		</nav>
	);
}

export default Nav;
